export default "__VITE_ASSET__z0EhygFR__"